import React from "react";
import { BriefcaseIcon, Building2Icon, GlobeIcon, GraduationCapIcon, LanguagesIcon, PartyPopperIcon, BoxIcon } from "lucide-react";
import { MockupTag } from "../ui/MockupTag";
import { ActionLink } from "../ui/ActionLink";
import { homeBenefits } from "../../data/home";
import { images } from "../../data/images";
const icons: BoxIcon[] = [GraduationCapIcon, LanguagesIcon, Building2Icon, GlobeIcon, BriefcaseIcon, PartyPopperIcon];

// Benefits as a bento grid: one large photo tile anchors six compact benefit tiles.
export function WhyBento() {
  const [lead, ...rest] = homeBenefits;
  const LeadIcon = icons[0];
  return <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-12 lg:grid-rows-[auto_auto_auto]" data-id="element-507" data-mp="16lgqcx3skesb">
      <div className="relative min-h-[360px] overflow-hidden rounded-[28px] md:col-span-2 lg:col-span-5 lg:row-span-3" data-id="element-508" data-mp="11t5f4y3lp6kg">
        <img src={images.speaking} alt="Two students practising a conversation in class" className="absolute inset-0 h-full w-full object-cover" data-id="element-509" data-mp="e2jkq9mirksx" />
        <div className="absolute inset-0 bg-black/35" aria-hidden="true" data-id="element-510" data-mp="rgsb1soejtmp" />
        <MockupTag note="Placeholder image" className="absolute left-4 top-4" data-id="element-511" data-mp="reeetghzkbdk" />
        <div className="absolute inset-x-4 bottom-4 rounded-[22px] bg-white p-5" data-id="element-512" data-mp="wdimg2p9i11s">
          <div className="flex items-center gap-3" data-id="element-513" data-mp="116k8qvrst2ve">
            <span className="flex h-11 w-11 items-center justify-center rounded-[13px] bg-brand text-white" aria-hidden="true" data-id="element-514" data-mp="164vh122g35bi">
              <LeadIcon className="h-5 w-5" data-id="element-515" data-mp="8ifzk0a0q7ny" />
            </span>
            <h3 className="type-h3 text-ink" data-id="element-516" data-mp="dg7rguanxts5">{lead.title}</h3>
          </div>
          <p className="mt-3 type-feature-desc" data-id="element-517" data-mp="dik916cie24o">{lead.text}</p>
        </div>
      </div>
      {rest.map((item, index) => {
      const Icon = icons[index + 1] ?? GraduationCapIcon;
      const wide = index === 0 || index === 3;
      return <div key={item.title} className={`flex flex-col rounded-[28px] bg-white p-6 ${wide ? 'lg:col-span-4' : 'lg:col-span-3'}`} data-id="element-518" data-mp="1tv91o7ipa1w2" data-mpi={index}>
            <span className="flex h-11 w-11 items-center justify-center rounded-[13px] bg-cream text-brand" aria-hidden="true" data-id="element-519" data-mp="1yshnqj6yyq2l">
              <Icon className="h-5 w-5" data-id="element-520" data-mp="3uz1oel12nl64" />
            </span>
            <h3 className="mt-5 type-h3 text-ink" data-id="element-521" data-mp="3px2mzgow6ybt">{item.title}</h3>
            <p className="mt-2 type-card-desc" data-id="element-522" data-mp="7rzh3tr3qiac">{item.text}</p>
          </div>;
    })}
      <div className="flex flex-col gap-6 rounded-[28px] bg-ink p-6 md:col-span-2 lg:col-span-4" data-id="element-523" data-mp="3qnxq5ytmtal">
        <p className="type-cta-title text-white" data-id="element-524" data-mp="3c6h1dk820aa8">Not sure of your level? Find out for free before you book.</p>
        <div className="mt-auto" data-id="element-525" data-mp="377mk4mpqits8">
          <ActionLink to="#enquire" data-id="element-526" data-mp="378fmzclkoz53">Start the level test</ActionLink>
        </div>
      </div>
    </div>;
}